import React from "react";
import { Row, Col } from "reactstrap";
import { BoldLabel } from "../../../../utils/budget-tool-specific";
import styled from "styled-components";
import { RebelColors, RebelHighlightBox } from "../../../../styles/rebel-experiences";

const RebelOutputDiv = styled(RebelHighlightBox)`
    margin-top: 0.75rem;
    padding: 1.5rem;
`;

const RebelBoldLabel = styled(BoldLabel)`
    color: ${RebelColors.gold};
    font-size: 0.75rem;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 0.5rem;
`;

const RebelTitle = styled.h3`
    color: ${RebelColors.gold};
    font-size: 1.5rem;
    font-weight: 700;
    margin-bottom: 1rem;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
`;

const RebelText = styled.p`
    color: ${RebelColors.text};
    margin-bottom: 0.75rem;
    line-height: 1.6;
    font-size: 0.875rem;

    strong {
        color: ${RebelColors.gold};
        font-weight: 600;
    }
`;

const RebelClientOutput = (props) => {

    const { data } = props;

    console.log('Client Output Data:', data);
    console.log('Notes field:', data.notes);

    // Handle notes - it could be a string, an object with .value, or undefined
    const notesText = typeof data.notes === 'string'
        ? data.notes
        : (typeof data.notes?.value === 'string' ? data.notes.value : '');

    return (
        <React.Fragment>
            <Row style={{marginTop: "10px", marginBottom: "50px"}}>
                <Col>
                    <RebelBoldLabel>Rebel Experience Summary</RebelBoldLabel>
                    <RebelOutputDiv>
                        <RebelTitle>{data.title?.value || "Untitled Rebel Experience"}</RebelTitle>
                        <RebelText><strong>Attendees:</strong> {data.attendees?.value?.toLocaleString()}</RebelText>
                        <RebelText><strong>Trip Length:</strong> {data.tripLength?.value?.toLocaleString()} nights / {((data.tripLength?.value || 0) + 1).toLocaleString()} days</RebelText>
                        <RebelText><strong>Currency:</strong> {data.currency?.value}</RebelText>
                        {notesText && (
                            <RebelText><strong>Notes:</strong> {notesText}</RebelText>
                        )}
                    </RebelOutputDiv>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default RebelClientOutput;